import { Icon } from '@sakhtar/design-system/react';
import { faDigits } from '../../../../lib/faDigits.js';
import type { ErrorMessage } from '../types.js';

export interface ErrorCardProps {
  readonly message: ErrorMessage;
  readonly onRetry: (message: ErrorMessage) => void;
  /** Puts the question text back into the composer. */
  readonly onEdit: (text: string) => void;
  readonly busy: boolean;
}

/** Frame J - the service failed: no tokens charged, the question is kept, «تلاش دوباره» / «ویرایش پرسش». */
export function ErrorCard({ message, onRetry, onEdit, busy }: ErrorCardProps) {
  return (
    <div className="sk-card ai-state ai-error" role="alert">
      <div className="ai-error__head">
        <span aria-hidden="true">
          <Icon name="shield" size="md" />
        </span>
        <span>تحلیل انجام نشد؛ توکنی کسر نشد.</span>
        <span
          className="sk-tag ai-sample-tag"
          title="این حالت نمایشی است و از انتخابگر «نمایش حالت» می‌آید"
        >
          نمونه
        </span>
      </div>
      <div className="ai-error__detail">
        اتصال به سرویس دستیار در میانهٔ محاسبه قطع شد. متن پرسش شما حفظ شده است.
        {message.attempt > 1 ? ` تلاش مجدد هم ناموفق بود (تلاش ${faDigits(message.attempt)}).` : ''}
      </div>
      <div className="ai-error__actions">
        <button
          type="button"
          className="sk-btn sk-btn--primary sk-btn--sm"
          disabled={busy}
          onClick={() => onRetry(message)}
        >
          تلاش دوباره
        </button>
        <button
          type="button"
          className="sk-btn sk-btn--ghost sk-btn--sm"
          onClick={() => onEdit(message.replay.userText)}
        >
          ویرایش پرسش
        </button>
      </div>
    </div>
  );
}
